import React from "react";
import { Container, CtaButton } from "./ui";
import { checkout } from "../data/content";
export function OfferBar() {
  return <section aria-label="Offer summary" className="bg-petrol py-5 text-white" data-id="element-96" data-mp="130bmniu6frkw">
      <Container className="flex flex-col items-center justify-between gap-4 text-center sm:flex-row sm:text-left" data-id="element-97" data-mp="p00vsfsvaczq">
        <div data-id="element-98" data-mp="t12wl12fmx3t">
          <p className="font-display text-2xl font-bold uppercase leading-none" data-id="element-99" data-mp="t0ul9dlyjzuq">
            1 book + 12-month calendar + 5 bonuses
          </p>
          <p className="mt-1.5 text-sm text-white/80" data-id="element-100" data-mp="k2hibi3zu48u">
            ${checkout.price} {checkout.currency} · One-time payment · 10-day money-back guarantee
          </p>
        </div>
        <CtaButton href="#offer-details" compact className="w-full sm:w-auto" data-id="element-101" data-mp="ac62oyay66m4">
          See the offer
        </CtaButton>
      </Container>
    </section>;
}